import { render, staticRenderFns } from "./MyAddress.vue?vue&type=template&id=1050d094&scoped=true&"
import script from "./MyAddress.vue?vue&type=script&lang=js&"
export * from "./MyAddress.vue?vue&type=script&lang=js&"
import style0 from "./MyAddress.vue?vue&type=style&index=0&id=1050d094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050d094",
  null
  
)

export default component.exports